<template>
    <div class="footer-v3-box">
        <div class="container">
            <div class="top-container typography-1200">
                <div>
                    <p class="title">服务热线：400-082-0021</p>
                    <p class="link-text">关于我们</p>
                    <!-- <p>模式研发单位：中国管理科学研究院学术委员会儿童新语境教育研究中心</p> -->
                    <p>项目倡导单位：北京联合国教科文组织协会</p>
                    <p>标准归⼝单位：中国成人教育协会</p>
                </div>
                <div>
                    <p class="title">友情链接</p>
                    <p>中国民办教育协会学前教育专业委员会</p>
                    <p>中国成人教育协会培训工作委员会</p>
                    <!-- <p>中国管理科学研究院学术委员会</p> -->
                    <p>北京联合国教科文组织协会</p>
                </div>
                <div class="img-list">
                    <div class="qrcode" v-for="(item, index) in imgList" :key="index">
                        <img :src="item.imgUrl">
                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-container">
            copynight@ 2012-{{ new Date().getFullYear() }} 北京中健时代教育科技有限责任公司 SouMate All Rights Reserved 京ICP备19000971号-1 京公网安备31010702004489号
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            imgList: [
                {
                    name: '抖音二维码',
                    imgUrl: require('@/assets/img/douyin-qrcode1.jpg')
                },
                {
                    name: '抖音二维码',
                    imgUrl: require('@/assets/img/douyin-qrcode2.jpg')
                },
                {
                    name: '公众号',
                    imgUrl: require('@/assets/img/weixin.png'),
                },
                {
                    name: '微信客服二维码',
                    imgUrl: require('@/assets/img/wechat-qrcode.jpg')
                }
            ],
        }
    }
}
</script>
<style scoped lang="less">
.footer-v3-box{
    margin-top: 59px;
    .container{
        background: #F6F6F6;
        padding: 32px 0;
        .top-container{
            // width: 1200px;
            // margin: 0 auto;
            display: flex;
            justify-content: space-between;
            p{
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
                margin-bottom: 14px;
                cursor: pointer;
                &:last-of-type{
                    margin-bottom: 0;
                }
            }
            .title{
                color: #000000;
            }
            .link-text{
                color: #BD1A2D;
                border-bottom: 1px solid #BD1A2D;
                width: fit-content;
            }
            .img-list{
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                grid-gap: 17px;
                .qrcode{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 66px;
                        height: 66px;
                        border-radius: 8px;
                    }
                    span{
                        font-size: 9px;
                        font-family: PingFang SC-Bold, PingFang SC;
                        font-weight: bold;
                        color: #000000;
                        line-height: 13px;
                        margin-top: 8px;
                    }
                }
            }
        }
    }
    .bottom-container{
        background: #BD1A2D;
        height: 55px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 55px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer-v3.vue